import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import BacktestService from "../../../service/backtest.service";
import Spinner from "../../common/spinner";
import Nav from "./common/nav";
import AssetAllocationFunds from "./asset_allocation_funds";
import BuildPortfolio from "./build_portfolio";
import ModelPortfolio from "./model_portfolio";
// import Helper from "../Create/universe_lite/helper/Helper";
import "./CreataPortfolioByAnalysis.style.scss";

class CreatePortfolioByAdvisor extends Component {
  _isMounted = false;
  state = {
    loading_predefined_portfolio: false,
    failed_fetching_predefined_portfolio: false,
    loading_backtest_data: false,
    triggerCallBack: false,
    selectedOption: "",
  };
  async componentWillMount() {
    this._isMounted = true;
    const {
      build_modelportfolios,
      direct_review_portfolio,
      direct_review_scenario_id,
    } = this.props;

    this.props.setPath(["Build a Portfolio (Advisor)"]);
    this.props.resetBuildPortfolio();

    if (
      this.props.build_a_portfolio_type !== "" &&
      build_modelportfolios &&
      build_modelportfolios.length === 0
    ) {
      this.fetchAllData({
        build_a_portfolio_type: this.props.build_a_portfolio_type,
        direct_review_portfolio,
        direct_review_scenario_id,
      });
    } else {
      this.props.changeBuildAPortfolioActiveData({
        name: this.props.build_a_portfolio_type,
      });
    }
  }
  componentDidMount() {
    this._isMounted = true;
    //resetting compare portfolio data
    this.props.resetComparePortfolioData();
    this.props.resetCreatePortfolioAnalyze();
    this.props.resetDirectReviewPortfolio();
    this.props.resetUniverseData();
    this.props.resetCurrentActiveStep(0);
    this.props.resetSecuritiesValidToNextStep(true);
    //****************/

    if (this.props.location) {
      let pathName = this.props.location.pathname;
      let p = pathName ? pathName.split("/") : "";
      if (pathName && p && p.length > 0) {
        this.triggerCallBackHandler({ name: p[p.length - 1], value: true });
        this.props.setBuildAPortfolioType(p[p.length - 1]);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      let pathName = nextProps.location.pathname;
      let p = pathName ? pathName.split("/") : "";
      if (pathName && p && p.length > 0) {
        this.triggerCallBackHandler({ name: p[p.length - 1], value: true });
        this.props.setBuildAPortfolioType(p[p.length - 1]);
      }
    } else if (
      this.props.build_a_portfolio_type === "" &&
      nextProps.location &&
      nextProps.location.pathname
    ) {
      let pathName = nextProps.location.pathname;
      let p = pathName ? pathName.split("/") : "";
      if (pathName && p && p.length > 0) {
        this.props.setBuildAPortfolioType(p[p.length - 1]);
      }
    }

    if (
      this.props.build_a_portfolio_type !== nextProps.build_a_portfolio_type
    ) {
      this.props.changeBuildAPortfolioActiveData({
        name: nextProps.build_a_portfolio_type,
      });
    }
  }

  fetchAllData = async ({
    build_a_portfolio_type,
    direct_review_portfolio,
    direct_review_scenario_id,
  }) => {
    this.setState({
      loading_predefined_portfolio: true,
      failed_fetching_predefined_portfolio: false,
    });
    try {
      // get model portfolios
      // this.setState({});
      let modifiedData;

      if (
        this.props.build_modelportfolios &&
        this.props.build_modelportfolios.length === 0
      ) {
        const response = await BacktestService.getPredefinedScenarios();
        const modelPortfolios = await response;

        modifiedData = this.modifyModelPortfolioData({
          modelportfolios: modelPortfolios.modelportfolios,
        });
        this.props.setModelPortfolios(modifiedData);
      } else {
        modifiedData = this.props.build_modelportfolios;
      }

      //--------------------------------------------------------------------
      let _scenario_ids = modifiedData.map((obj) => obj.id);
      let _scenario_short_list_cp = {};
      let _scenario_short_list_ms = {};

      let _backTest_data_cp = {};
      let _backTest_data_ms = {};

      let _histMetrics_cp = {};
      let _histMetrics_ms = {};

      for (let scenario_id of _scenario_ids) {
        // check reference scenario id present
        let make_ms_cp_diff_call = true;
        let check_ref_scenario_id = false;

        // ----- shortlist -----
        if (direct_review_portfolio === false) {
          const ms_response = await BacktestService.getScenarioShortlist(
            scenario_id,
            "MS"
          );
          // const ms_res = await ms_response;
          _scenario_short_list_ms[scenario_id] = ms_response;

          if (make_ms_cp_diff_call) {
            const cp_response = await BacktestService.getScenarioShortlist(
              scenario_id,
              "CP"
            );
            const cp_res = await cp_response;
            _scenario_short_list_cp[scenario_id] = cp_res;
          } else {
            _scenario_short_list_cp[scenario_id] = ms_response;
          }

          // ----- backtest -----
          const ms_response_bt = await BacktestService.getBacktest(
            `${scenario_id}`,
            "DUMMY",
            "BACKTEST"
          );

          // const ms_res_bt = await ms_response_bt;
          _backTest_data_ms[scenario_id] = ms_response_bt;

          if (check_ref_scenario_id) {
            const cp_response_bt = await BacktestService.getBacktest(
              `${scenario_id}`,
              "DUMMY",
              "BACKTEST"
            );
            // const cp_res_bt = await cp_response_bt;
            _backTest_data_cp[scenario_id] = cp_response_bt;
          } else {
            _backTest_data_cp[scenario_id] = ms_response_bt;
          }
        }

        // ----- perf histmetrics -----
        const ms_response_hm = await BacktestService.getPerfHistMetrics(
          `${scenario_id}`,
          "BACKTEST"
        );
        const ms_res_hm = await ms_response_hm;
        _histMetrics_ms[scenario_id] = ms_res_hm;

        if (check_ref_scenario_id) {
          const cp_response_hm = await BacktestService.getPerfHistMetrics(
            `${scenario_id}`,
            "BACKTEST"
          );
          const cp_res_hm = await cp_response_hm;
          _histMetrics_cp[scenario_id] = cp_res_hm;

          if (this._isMounted) {
            this.setState({
              loading_predefined_portfolio: false,
              failed_fetching_predefined_portfolio: false,
              loading_backtest_data: true,
            });
          }
        } else {
          _histMetrics_cp[scenario_id] = ms_res_hm;

          if (this._isMounted) {
            this.setState({
              loading_predefined_portfolio: false,
              failed_fetching_predefined_portfolio: false,
              loading_backtest_data: true,
            });
          }
        }
      }
      this.props.setScenarioIDBasedData({
        key: "scenario_short_list_symbols",
        obj: _scenario_short_list_ms,
      });
      this.props.setReferenceScenarioIDBasedData({
        key: "scenario_short_list_symbols",
        obj: _scenario_short_list_cp,
      });

      this.props.setScenarioIDBasedData({
        key: "backtest_data",
        obj: _backTest_data_ms,
      });
      this.props.setReferenceScenarioIDBasedData({
        key: "backtest_data",
        obj: _backTest_data_cp,
      });

      this.props.setScenarioIDBasedData({
        key: "build_histmetrics",
        obj: _histMetrics_ms,
      });
      this.props.setReferenceScenarioIDBasedData({
        key: "build_histmetrics",
        obj: _histMetrics_cp,
      });

      if (build_a_portfolio_type === "customPortfolio") {
        this.props.setScenarioShortlist(_scenario_short_list_cp);
        this.props.setBacktestData(_backTest_data_cp);
        this.props.setHistmetricsData(_histMetrics_cp);
        this.setState({
          loading_backtest_data: false,
        });
      } else {
        this.props.setScenarioShortlist(_scenario_short_list_ms);
        this.props.setBacktestData(_backTest_data_ms);
        this.props.setHistmetricsData(_histMetrics_ms);
        this.setState({
          loading_backtest_data: false,
        });
      }

      // fetching modify portfolio scenario id data
      if (
        direct_review_portfolio &&
        direct_review_scenario_id &&
        build_a_portfolio_type
      ) {
        let type =
          build_a_portfolio_type === "customPortfolio"
            ? "CP"
            : build_a_portfolio_type === "managerSelection"
            ? "MS"
            : "MS";
        const shortlist_symbols = await BacktestService.getScenarioShortlist(
          direct_review_scenario_id,
          type
        );
        this.props.setDirectReviewShortListSymbols({
          shortlist_symbols,
        });
      }

      //-------------------------------------------
    } catch (error) {
      console.log(error);
      this.setState({
        loading_predefined_portfolio: false,
        loading_backtest_data: false,
        failed_fetching_predefined_portfolio: true,
      });
      this.props.resetBuildAPortfolio();
    }
  };

  modifyModelPortfolioData = ({ modelportfolios }) => {
    const portfolios = [];
    for (let i in modelportfolios) {
      let line = modelportfolios[i];
      let key = -1;
      for (let k in portfolios) {
        if (portfolios[k].id !== line.scenario_id) continue;
        else {
          key = k;
          break;
        }
      }

      if (key > -1) {
        portfolios[key].data.push(line);
      } else {
        portfolios.push({
          name: line.investment_objective,
          id: line.scenario_id,
          data: [line],
        });
      }
    }

    return portfolios;
  };

  triggerCallBackHandler = ({ value, name }) => {
    this.setState({
      triggerCallBack: value,
      selectedOption: name,
    });

    setTimeout(
      () =>
        this.setState({
          triggerCallBack: false,
        }),
      1000
    );
  };
  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const {
      loading_predefined_portfolio,
      failed_fetching_predefined_portfolio,
      loading_backtest_data,
      triggerCallBack,
      selectedOption,
    } = this.state;
    const {
      scenario_short_list_symbols,
      build_a_portfolio_type,
      direct_review_portfolio,
      direct_review_scenario_shortlist_symbols,
      create_new_questionnaire_client,
    } = this.props;
    return (
      <div className="page-content">
        <div className="head-section">
          <h1 className="text-uppercase"></h1>
        </div>
        <div className="buildPortfolio__main">
          {/* <Nav
            triggerCallBack={triggerCallBack}
            selectedTab={selectedOption}
            disableTab={direct_review_portfolio}
          /> */}
          <div className="tab-content">
            {(loading_predefined_portfolio || loading_backtest_data) &&
            create_new_questionnaire_client === false ? (
              <Spinner />
            ) : null}
            {failed_fetching_predefined_portfolio ? (
              <div className="tab-content_failed">
                Failed to load data, please try again later
              </div>
            ) : null}
            {((scenario_short_list_symbols &&
              Object.keys(scenario_short_list_symbols).length > 0) ||
              (direct_review_portfolio &&
                direct_review_scenario_shortlist_symbols &&
                direct_review_scenario_shortlist_symbols.length > 0)) &&
            build_a_portfolio_type !== "" ? (
              <Fragment>
                <div
                  id="cpa_1"
                  className={`tab-pane fade ${
                    build_a_portfolio_type === "customPortfolio" ||
                    build_a_portfolio_type === "managerSelection"
                      ? "in active"
                      : ""
                  }`}
                >
                  <BuildPortfolio />
                </div>
                <div
                  id="cpa_2"
                  className={`tab-pane fade ${
                    build_a_portfolio_type === "assetAllocationFunds"
                      ? "in active"
                      : ""
                  }`}
                >
                  <AssetAllocationFunds
                    triggerCallBackHandler={this.triggerCallBackHandler}
                  />
                </div>
                <div
                  id="cpa_3"
                  className={`tab-pane fade ${
                    build_a_portfolio_type === "modelPortfolios"
                      ? "in active"
                      : ""
                  }`}
                >
                  <ModelPortfolio
                    triggerCallBackHandler={this.triggerCallBackHandler}
                  />
                </div>
              </Fragment>
            ) : create_new_questionnaire_client ? (
              <div
                id="cpa_3"
                className={`tab-pane fade ${
                  build_a_portfolio_type === "modelPortfolios"
                    ? "in active"
                    : ""
                }`}
              >
                <ModelPortfolio
                  triggerCallBackHandler={this.triggerCallBackHandler}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  ({
    buildPortfolio: {
      build_a_portfolio: { active_portfolio_id },
      build_modelportfolios,
      scenario_short_list_symbols,
      build_a_portfolio_type,
      direct_review: {
        direct_review_portfolio,
        direct_review_scenario_id,
        direct_review_scenario_shortlist_symbols,
      },
      model_portfolios: { create_new_questionnaire_client },
    },
  }) => ({
    active_portfolio_id,
    build_modelportfolios,
    scenario_short_list_symbols,
    build_a_portfolio_type,
    direct_review_portfolio,
    direct_review_scenario_id,
    direct_review_scenario_shortlist_symbols,
    create_new_questionnaire_client,
  }),
  (dispatch) => ({
    setModelPortfolios: (modelportfolios) =>
      dispatch({
        type: "BUILD_SET_MODEL_PORTFOLIOS",
        payload: modelportfolios,
      }),

    setScenarioShortlist: (payload) =>
      dispatch({
        type: "BUILD_SET_SCENARIO_SHORTLIST_SYMBOLS",
        payload,
      }),
    setDefaultPortfolioID: ({ activePortfolioID }) =>
      dispatch({
        type: "BUILD_SET_ACTIVE_PORTFOLIO",
        payload: { activePortfolioID },
      }),

    setBacktestData: (payload) =>
      dispatch({
        type: "BUILD_SET_BACKTEST_DATA",
        payload,
      }),

    setHistmetricsData: (payload) =>
      dispatch({
        type: "BUILD_SET_HISTMETRICS",
        payload,
      }),

    setScenarioIDBasedData: ({ key, obj }) =>
      dispatch({
        type: "BUILD_SET_SCENARIO_ID_BASED_DATA",
        payload: { key, obj },
      }),
    setReferenceScenarioIDBasedData: ({ key, obj }) =>
      dispatch({
        type: "BUILD_SET_REFERENCE_SCENARIO_ID_BASED_DATA",
        payload: { key, obj },
      }),

    changeBuildAPortfolioActiveData: ({ name }) =>
      dispatch({
        type: "CHANGE_BUILD_A_PORTFOLIO_ACTIVE_TYPE_DATA",
        payload: { name },
      }),
    resetBuildPortfolio: () =>
      dispatch({
        type: "BUILD_A_PORTFOLIO_RESET",
      }),
    resetComparePortfolioData: (payload) =>
      dispatch({
        type: "RESET_COMPARE_PORTFOLIO",
      }),
    resetCreatePortfolioAnalyze: () =>
      dispatch({
        type: "RESET_CREATE_PORTFOLIO_ANALYZE",
      }),
    resetDirectReviewPortfolio: () =>
      dispatch({
        type: "RESET_DIRECT_REVIEW_PORTFOLIO_OPTIMIZE_DATA",
      }),
    resetUniverseData: () =>
      dispatch({
        type: "SET_UNIVERSE_DATA",
        payload: [],
      }),
    resetCurrentActiveStep: (value) =>
      dispatch({ type: "SET_ACTIVE_STEP_COUNT", payload: value }),
    resetSecuritiesValidToNextStep: (payload) =>
      dispatch({ type: "SET_UNIVERSE_SECURITYVALIDITY", payload }),
    setBuildAPortfolioType: (payload) => {
      dispatch({
        type: "BUILD_A_PORTFOLIO_TYPE",
        payload,
      });
    },
    resetBuildAPortfolio: () => {
      dispatch({
        type: "RESET_BUILD_A_PORTFOLIO",
      });
    },
    setDirectReviewShortListSymbols: ({ shortlist_symbols }) =>
      dispatch({
        type: "BUILD_DIRECT_REVIEW_PORTFOLIO_SHORTLIST",
        payload: { shortlist_symbols },
      }),
  })
)(CreatePortfolioByAdvisor);



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/CreatePortfolioByAdvisor.jsx